module.exports = __webpack_public_path__ + "static/media/carolina-herrera-sexy-man-big.43db7592.png";